module.exports = __webpack_public_path__ + "static/resume-26b518beb60efc7b237b7ad5c71d9583.pdf";